/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Dropdown/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentLeftClick from 'DesignSystem/Popover/PopoverContentLeftClick/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2ChevronDown from 'DesignSystem/Svgs/Tysiav2ChevronDown/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Dropdown({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/CollapsibleSidebar/MonthAndYearSelector/Dropdown"
  
}) {
let sidebarDateValueData = fromData.useDataValue({ viewPath,
context: 'sidebar',
path: 'date',
})
let constantData = 'MMMM yyyy'
let tabSelectedTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.time_zone_id',
})
let aggregateData = fromFormat.formatTzDate(sidebarDateValueData, constantData, tabSelectedTimeZoneIdValueData)
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
 cursor="pointer"
>
{childProps => (
<div
  data-testid="Dropdown.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral900}
 weight="medium"
 data="sidebar.date"
 data="'MMMM yyyy'"
 data="tab.selected.time_zone_id"
 aggregate="/Data/format.js formatTzDate"
 text={aggregateData}
/>
<Tysiav2ChevronDown
  viewPath={`${viewPath}/Tysiav2ChevronDown`}
 marginLeft={dtSpaceXs}
/>
</div>
)}
</PopoverTrigger>
<PopoverContentLeftClick
{...childProps}
  viewPath={`${viewPath}/PopoverContentLeftClick`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentLeftClick>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}